import { get } from '@core/api/baseApi';
import { GetUserSettingsResponse } from '@core/types';

const getUserPreferences = (): Promise<GetUserSettingsResponse> => get(`/users/settings`);

export default getUserPreferences;
